import { create } from 'zustand';
import { getAllCrmCategories, getCrmCategories, getCustomerData, getCxComplaintTicket, getTicketConfig, getTicketSlot, postTicket } from '../api';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { persist } from 'zustand/middleware';

export const useOrderSearchForTicket = create(
  persist(
    (set, get) => ({
      customerDetails: [],
      crmCategories: [],
      allCrmCategories: [],
      isLoading: false,
      isError: false,
      fetchCustomerDetails: async (key) => {
        try {
          const response = await getCustomerData(key);
          set({ customerDetails: response.data, isLoading: false });
        } catch (error) {
          const errorMessage = _.get(error, ['response', 'data', 'message'], 'Failed to fetch customer details.');
          const nestedErrorMessage = _.get(error, ['response', 'data', 'message', 'message'], errorMessage);
          set({ isError: true, isLoading: false });
          toast.error(nestedErrorMessage);
        }
      },
      fetchCrmCategories: async () => {
        try {
          const { crmCategories } = get();
          if (_.isEmpty(crmCategories)) {
            const response = await getCrmCategories();
            set({ crmCategories: response.data.data, isLoading: false });
          }
        } catch (error) {
          const errorMessage = _.get(error, ['response', 'data', 'message'], 'Failed to fetch CRM categories.');
          const nestedErrorMessage = _.get(error, ['response', 'data', 'message', 'message'], errorMessage);
          set({ isError: true, isLoading: false });
          toast.error(nestedErrorMessage);
        }
      },
      fetchAllCrmCategories: async () => {
        try {
          const { allCrmCategories } = get();
          if (_.isEmpty(allCrmCategories)) {
            const response = await getAllCrmCategories();
            set({ allCrmCategories: response.data.data, isLoading: false });
          }
        } catch (error) {
          const errorMessage = _.get(error, ['response', 'data', 'message'], 'Failed to fetch all CRM categories.');
          const nestedErrorMessage = _.get(error, ['response', 'data', 'message', 'message'], errorMessage);
          set({ isError: true, isLoading: false });
          toast.error(nestedErrorMessage);
        }
      },
    }),
    {
      name: "order-search-ticket-store",
      partialize: (state) => ({ crmCategories: state.crmCategories }),
    }
  )
);

export const useCreateTicket = create(set => ({
  ticketResponse: {},
  ticketLoading: false,
  createTicket: async (payload, key) => {
    try {
      set({ ticketLoading: true });
      const response = await postTicket(payload);
      set({ ticketResponse: response.data });
      toast.success('Ticket Created');
    } catch (error) {
      const statusCode = _.get(error, ['response', 'status']);
      if (statusCode === 409) {
        const message = _.get(error, ['response', 'data', 'message'], 'Slot already available.')
        toast.warn(message.replaceAll('_', ' '));
      } else {
        const fallbackError = _.get(error, ['message'], 'Failed to Create Ticket.');
        const errorMessage = _.get(error, ['response', 'data', 'message'], fallbackError);
        const nestedErrorMessage = _.get(error, ['response', 'data', 'message', 'message'], errorMessage);
        toast.error(nestedErrorMessage);
      }
    } finally {
      set({ ticketLoading: false });
    }
  },
}));

export const useTicketConfig = create(set => ({
	ticketConfig: {},
	fetchTicketConfig: async caseId => {
		try {
      if(caseId){
        const response = await getTicketConfig(caseId);
        set({ ticketConfig: response.data });
      }
		} catch (error) {
      const errorMessage = _.get(error, ['response', 'data', 'message'], 'Something went wrong');
			toast.error(errorMessage);
		}
	},
}));

export const useTicketSlots = create(set => ({
	ticketSlots: {},
  ticketSlotLoading: false,
  fetchTicketSlotData: async (category) => {
    try {
      set({ allSlotLoading: true, error: null });
      const response = await getTicketSlot(category);
      set({ ticketSlots: response.data, ticketSlotLoading: false });
    } catch (error) {
      toast.error(error?.response?.data?.message);
      set({ error: error.message, ticketSlotLoading: false });
    }
  }
}));

export const useCxComplaintTicket = create(set => ({
	ticketData: [],
  ticketLoading: false,
  error: false,
  rowCount: 0,
  fetchCxComplaintTicket: async (sd, ed, newPage, query) => {
    try {
      set({ ticketLoading: true, error: null });
      const response = await getCxComplaintTicket(sd, ed, newPage, query);
      const { row_count, tickets } = response.data;
      set({ ticketData: tickets, rowCount: row_count, ticketLoading: false });
    } catch (error) {
      toast.error(error?.response?.data?.message);
      set({ error: error.message, ticketLoading: false });
    }
  }
}));